module.exports = __webpack_public_path__ + "img/setutsa_logo_azul.71f5f481.png";